export default function (context, agreement) {
    let ag = context.state.list.filter(i => {
        return i.code === agreement.code
    })[0];
    let form = context.rootState.finances.pay.form;
    let operation = context.rootGetters['dictionary/paymentOperation/getById'](form.PaymentOperationID);
    let d = {};
    d.mask = operation.PaymentFor;
    d.code = '';
    d.datebeg = '';
    d.request = '';
    d.debt = '';
    d.operator = '';
    d.operatorlegal = '';
    d.tourist = '';
    d.contragent = '';
    d.contragentlegal = '';
    d.clientdebt = '';
    d.operatordebt = '';
    d.country = '';
    d.datenow = '' + (new Date().getDate() > 9 ? '' : '0') + new Date().getDate() + '.' + (new Date().getMonth() > 8 ? '' : '0') + (new Date().getMonth() + 1) + '.' + new Date().getFullYear();
    d.datepay = form.PaymentDate;
    if (operation.OperationType) {
        d.code = ag.code;
        d.datebeg = ag.startDate;
        d.country = ag.country;

        d.request = '';
        d.clientdebt = '';
        let debt = 0;
        agreement.requests.forEach(i => {
            d.request += d.request ? ', ' : '';
            d.request += i.name;
            if (i.type !== 2) debt += i.out;
        });
        ag.requests.forEach(i => {
            if (i.type === 1) d.clientdebt = i.inp;
        });
        let currency = agreement.iso;
        d.clientdebt += ' ' + currency;
        d.debt = '' + debt + ' ' + currency;
        d.operatordebt = '' + debt + ' ' + currency;
        d.tourist = '';
        d.operator = '';
        ag.contragents.forEach(i => {
            if (i.type === 1) {
                d.tourist = i.label;
            }
            if (i.type === 3) {
                d.operator += d.operator ? ', ' : '';
                d.operator += i.label;
                if (i.value === form.ContragentID) d.contragent = i.label;
            }
        });
        d.operatorlegal = '';
        d.contragentlegal = '';
        ag.legals.forEach(i => {
            if (i.type === 3) {
                d.operatorlegal += d.operatorlegal ? ', ' : '';
                d.operatorlegal += i.label;
                if (i.value === form.PartnerLegalEntityId) d.contragentlegal = i.label;
            }
        });
        let r = d.mask || '';
        r = r.replace(/{code}/g, d.code);
        r = r.replace(/{datebeg}/g, d.datebeg);
        r = r.replace(/{request}/g, d.request);
        r = r.replace(/{operator}/g, d.operator);
        r = r.replace(/{operatorlegal}/g, d.operatorlegal);
        r = r.replace(/{tourist}/g, d.tourist);
        r = r.replace(/{contragent}/g, d.contragent);
        r = r.replace(/{contragentlegal}/g, d.contragentlegal);
        r = r.replace(/{datenow}/g, d.datenow);
        r = r.replace(/{datepay}/g, d.datepay);
        r = r.replace(/{debt}/g, d.debt);
        r = r.replace(/{clientdebt}/g, d.clientdebt);
        r = r.replace(/{operatordebt}/g, d.operatordebt);
        r = r.replace(/{country}/g, d.country);
        ag.comment = r;
    }
}
